import React from 'react';
import {
  hydrate,
  QueryCache,
  QueryClient,
  QueryClientConfig,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClientConfig = {
  queryCache: new QueryCache({}),
  defaultOptions: {
    queries: {
      suspense: false,
      refetchOnWindowFocus: false,
      retry: 0, // don't retry queries, i.e. require page refresh
      cacheTime: 10 * 60 * 1000,
      refetchInterval: false,
      keepPreviousData: true,
      staleTime: 10 * 60 * 1000,
    },
  },
} satisfies QueryClientConfig;

export const queryClient = new QueryClient(queryClientConfig);

// hydate query client on application start
hydrate(queryClient, window.__QUERY_STATE__, {
  defaultOptions: queryClientConfig.defaultOptions,
});

// Dev tools only show on development env by default
const QueryProvider = ({ children }: React.PropsWithChildren) => (
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />

    {children}
  </QueryClientProvider>
);

export default QueryProvider;
